import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DtoAgentNotification, DtoIncomingNotification, DtoTerminateVoiceCall, DtoLocationDetails, DtoTeamsAgentDetails, DtoCallHoldDetails, DtoRoomData, DtoUpdateVideoRoomDetails, DtoLocationData } from "../dto/dashboard.dto";
import { disconnectAudioCall,checkCallSid, loggerHelper } from "../services/sharedService";
import { showToaster } from "./toastSlice"

const defaultValue: DtoAgentNotification = {
    notificationData: [],
    inHandOffCall:"",
    playNotificationRinger: false,
    loopRinger: true,
    inCallNotificationIdRef: undefined,
    inDirectCall: false,
    removedCallInstance: [],
    inComingCallInstanceTrigger: false,
    defaultActiveKeys: ["0"],
    device: null,
    voiceCallInstance: [],
    audioNotificationData: undefined,
    audioCallTimer: 0,
    audioCallStartTimer: false,
    outBoundCallLocationDetails: undefined,
    terminateOutBoundVoiceCall: false,
    outBoundCallPhoneNumber: "",
    outBoundCallFromPhoneNumber: "",
    outBoundCallConnection: undefined,
    outBoundCallAddParticipant: false,
    agentToAgentOutBoundVoiceCallAgentId: "",
    agentToAgentOutBoundVoiceCallAgentDetails: undefined,
    voiceCallAudioMute: false,
    callAccepted: false,
    callDetails: undefined,
    disconnectCall: false,
    disconnectEndCallId: undefined,
    holdCallDetails: undefined,
    appLoader: false,
    dndTimer: {},
    videoRoomDetails: undefined,
    videoCallTriggerFlag: undefined,
    missedNotificationTrigger: false,
    voiceMailNotificationTrigger: false,
    locationDetails: {},
    errorMessageToaster: undefined,
    locationsData: { primary: [], secondary: [], others: [] },
    restartMotionStateLocationId: [],
    notificationAudioDevice:{},
    triggersetSinkId : true,
    enableDisable : "",
    audioCallError : false,
};

export const notificationsSlice = createSlice({
    name: "notificationsSlice",
    initialState: defaultValue,
    reducers: {
        setAgentNotifications: (state, action: PayloadAction<DtoIncomingNotification[]>) => {
            let newValueState: DtoAgentNotification = { ...state };
            if(!Object.keys(action.payload).length){
                newValueState.playNotificationRinger = false;
            }
            newValueState.notificationData = [...action.payload];
            return newValueState;
        },
        setInHandOffCall:(state, action: PayloadAction<string|undefined>)=>{
            let newValueState:DtoAgentNotification = {...state};
            newValueState.inHandOffCall = action.payload;
            return newValueState;
        },
        removeAudioCallNotificationById: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            const filteredValue = newValueState.notificationData.filter(
                (item) => item.call_sid !== action.payload
            );
            newValueState.notificationData = [...filteredValue];
            return newValueState;
        },
        playPauseRinger: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.playNotificationRinger = action.payload;
            return newValueState;
        },
        setLoopRinger: (state, action: PayloadAction<boolean>) => {
            state.loopRinger = action.payload;
        },
        setInCallNotificationIdRef: (state, action: PayloadAction<string|undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.inCallNotificationIdRef = action.payload;
            return newValueState;
        },
        setInDirectCall: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.inDirectCall = action.payload;
            return newValueState;
        },
        setRemovedCallInstance: (state, action: PayloadAction<string[]>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.removedCallInstance = [...newValueState.removedCallInstance, ...action.payload];
            return newValueState;
        },
        setInComingCallInstanceTrigger: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.inComingCallInstanceTrigger = action.payload;
            return newValueState;
        },
        setDefaultActiveKeys: (state, action: PayloadAction<string[]>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.defaultActiveKeys =
                action.payload && action.payload.length
                    ? [...action.payload]
                    : [...[]];
            return newValueState;
        },
        setAudioNotificationData: (state, action: PayloadAction<DtoIncomingNotification | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.audioNotificationData = action.payload;
            return newValueState;
        },
        setOutBoundCallLocationDetails: (state, action: PayloadAction<DtoLocationDetails | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.outBoundCallLocationDetails = action.payload;
            return newValueState;
        },
        terminateOutBoundVoiceCall: (state) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.terminateOutBoundVoiceCall = true;
            newValueState.audioCallTimer = 0;
            newValueState.audioCallStartTimer = false;
            newValueState.voiceCallAudioMute = false;
            newValueState.inCallNotificationIdRef = undefined;
            newValueState.outBoundCallPhoneNumber =  '';
            newValueState.outBoundCallFromPhoneNumber = '';
            newValueState.outBoundCallLocationDetails = undefined;
            newValueState.agentToAgentOutBoundVoiceCallAgentDetails =  undefined;
            disconnectAudioCall(undefined, (newValueState && newValueState.outBoundCallConnection && newValueState.outBoundCallConnection.parameters && newValueState.outBoundCallConnection.parameters.CallSid)? newValueState.outBoundCallConnection.parameters.CallSid : undefined);
            if (newValueState.outBoundCallConnection && newValueState.outBoundCallConnection.parameters && newValueState.outBoundCallConnection.parameters.CallSid){
                const filteredValue = newValueState.voiceCallInstance.filter((voiceCallInstance: any) => voiceCallInstance['customParameters'].get('call_sid') !== newValueState.outBoundCallConnection.parameters.CallSid);
                newValueState.voiceCallInstance = [...filteredValue];
            }
            newValueState.outBoundCallConnection = undefined;
            newValueState.outBoundCallAddParticipant = false;
            return newValueState;
        },
        setTerminatedOutBoundVoiceCall: (state) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.terminateOutBoundVoiceCall = false;
            return newValueState;
        },
        setVoiceCallAudioMute: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.voiceCallAudioMute = action.payload;
            return newValueState;
        },
        setOutBoundCallPhoneNumber: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.outBoundCallPhoneNumber =  action.payload;
            return newValueState;
        },
        setOutBoundCallFromPhoneNumber: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.outBoundCallFromPhoneNumber =  action.payload;
            return newValueState;
        },
        setOutBoundCallConnection: (state, action: PayloadAction<any | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.outBoundCallConnection =  action.payload;
            if (newValueState.outBoundCallConnection && !newValueState.outBoundCallAddParticipant){
                newValueState.outBoundCallAddParticipant = false;
                if (newValueState.outBoundCallConnection.customParameters.get('callerBound') === 'outgoing call' && newValueState.outBoundCallConnection.parameters.CallSid){
                    newValueState.outBoundCallAddParticipant = true;
                }
            }
            return newValueState;
        },
        setAudioCallTimer: (state, action: PayloadAction<number>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.audioCallTimer = newValueState.audioCallTimer + action.payload;
            return newValueState;
        },
        setAudioCallStartTimer: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.audioCallStartTimer = action.payload;
            return newValueState;
        },
        setAgentToAgentOutBoundVoiceCallAgentId: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.agentToAgentOutBoundVoiceCallAgentId =  action.payload;
            return newValueState;
        },
        setAgentToAgentOutBoundVoiceCallAgentDetails: (state, action: PayloadAction<DtoTeamsAgentDetails | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.agentToAgentOutBoundVoiceCallAgentDetails =  action.payload;
            return newValueState;
        },
        setCallAccepted: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.callAccepted = action.payload;
            return newValueState;
        },
        setCallDetails: (state, action: PayloadAction<any>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.callDetails = action.payload;
            return newValueState;
        },
        setNotificationsListener: (state, action: PayloadAction<DtoIncomingNotification>) => {
            let newValueState: DtoAgentNotification = { ...state };
            if (
                (action.payload.isAcknowledged && !newValueState.inCallNotificationIdRef) ||
                (action.payload.isAcknowledged &&
                    newValueState.inCallNotificationIdRef !==
                    action.payload.notificationId) ||
                (action.payload.isAcknowledged &&
                    newValueState.inDirectCall)
            ) {
                console.log("came inside");
                const updatedNotificationData = newValueState.notificationData.filter(
                    (item) => item.notificationId !== action.payload.notificationId
                );
                if (updatedNotificationData){
                    let missedNotification: string | null = localStorage.getItem("missed_notification");
                    let missedNotificationArray: Array<any> = [];
                    if (missedNotification){
                        missedNotificationArray = JSON.parse(missedNotification);
                    }else{
                        missedNotificationArray = [];
                    }
                    localStorage.setItem("missed_notification", JSON.stringify([...missedNotificationArray, ...newValueState.notificationData.filter(notification => !updatedNotificationData.includes(notification))]));
                    newValueState.missedNotificationTrigger = true;
                }
                newValueState.notificationData = [...updatedNotificationData];
                if (updatedNotificationData.length <= 1) {
                    newValueState.playNotificationRinger = false;
                }
            } else {
                // Setting the incoming notification for voice call.
                if (action.payload.call_type === "voice") {
                    let notificationArray = [
                        ...newValueState.notificationData,
                    ];
                    // checking for the notification already exists and call instance for the notification is present
                    if (
                        notificationArray.find(
                            (x: DtoIncomingNotification) =>
                                x.call_sid === action.payload.call_sid
                        ) === undefined &&
                        !(newValueState.removedCallInstance &&
                        newValueState.removedCallInstance.includes(action.payload.call_sid!))
                    ) {
                        notificationArray = [
                            ...notificationArray,
                            ...[action.payload],
                        ];
                        // Play music only if notification is not already
                        if (!action.payload.isAcknowledged) {
                            newValueState.playNotificationRinger = true;
                            if (
                                newValueState.inCallNotificationIdRef
                            ) {
                                setTimeout(() => {
                                    playPauseRinger(false);
                                }, 2000);
                            }
                        }
                    }
                    newValueState.notificationData = [...notificationArray];
                } else if (action.payload.call_type === "video") {
                    let notificationArray = [
                        ...newValueState.notificationData,
                    ];
                    // pushing only the new location notification to the setIncomingNotifications. (or) Only the QR triggered notifications for same locations
                    if (
                        ((notificationArray.find(
                            (x: DtoIncomingNotification) =>
                                x.locationId === action.payload.locationId &&
                                x.call_type === "video"
                        ) === undefined) || 
                        notificationArray.find(
                            (x: DtoIncomingNotification) =>
                                x.notificationId === action.payload.notificationId &&
                                action.payload.tenant_triggered &&
                                x.call_type === "video"
                        ) === undefined)
                    ) {
                        notificationArray = [
                            ...notificationArray,
                            ...[action.payload],
                        ];
                        // Play music only if notification is not already
                        if (!action.payload.isAcknowledged) {
                            newValueState.playNotificationRinger = true;
                            if (
                                newValueState.inCallNotificationIdRef
                            ) {
                                setTimeout(() => {
                                    playPauseRinger(false);
                                }, 2000);
                            }
                        }
                    }
                    newValueState.notificationData = [...notificationArray];
                }else if (action.payload.call_type && ["kiosk-offline", "kiosk-online"].includes(action.payload.call_type?.toLocaleLowerCase()!)) {
                    let missedNotification: string | null = localStorage.getItem("missed_notification");
                    let missedNotificationArray: Array<any> = [];
                    if (missedNotification){
                        missedNotificationArray = JSON.parse(missedNotification);
                    }else{
                        missedNotificationArray = [];
                    }
                    localStorage.setItem("missed_notification", JSON.stringify([...missedNotificationArray, ...[action.payload]]));
                    newValueState.missedNotificationTrigger = true;
                }
                let newArray = [
                    ...newValueState.defaultActiveKeys,
                ];
                if (!newArray.includes("0")) {
                    newArray.push("0");
                }
                newValueState.defaultActiveKeys = [...newArray]
            }
            return newValueState;
        },
        initializeAudioDevice: (state, action: PayloadAction<any>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.device = action.payload;
            return newValueState;
        },
        setVoiceCallInstance: (state, action: PayloadAction<any>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.voiceCallInstance = action.payload;
            return newValueState;
        },
        appendVoiceCallInstance: (state, action: PayloadAction<any>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.voiceCallInstance = [...action.payload, ...newValueState.voiceCallInstance];

            const callerId = action.payload[0]['customParameters'].get('call_sid') && checkCallSid(action.payload[0]['customParameters'].get('call_sid'));
            loggerHelper("callerId in appendVoiceCallInstance",callerId);
            loggerHelper(newValueState.voiceCallInstance?.length,'newValueState.voiceCallInstance.length')
            if (newValueState.holdCallDetails && newValueState.holdCallDetails.callSid && checkCallSid(newValueState.holdCallDetails.callSid) === callerId){
                const currentVoiceCallInstance = newValueState.voiceCallInstance.filter((voiceCallInstance: any) => checkCallSid(voiceCallInstance['customParameters'].get('call_sid')) === callerId);
                if (callerId && currentVoiceCallInstance && currentVoiceCallInstance.length > 0) {
                    currentVoiceCallInstance[0].accept();
                    newValueState.appLoader = false;
                    newValueState.audioCallTimer = newValueState.holdCallDetails.callTimer! + Math.floor((new Date().getTime() - new Date(newValueState.holdCallDetails.callHoldTime!).getTime()));
                    const oldArray: Array<DtoIncomingNotification> = [...newValueState.notificationData];
                    let notificationIndex: number = oldArray.findIndex((item) => checkCallSid(item.call_sid) === callerId);
                    if (oldArray && oldArray[notificationIndex] && notificationIndex >= 0) {
                        if ("callback" in oldArray[notificationIndex] && oldArray[notificationIndex].callback && oldArray[notificationIndex].callback !== undefined) {
                            newValueState.inCallNotificationIdRef = oldArray[notificationIndex].notificationId;
                            const callBackFunction = oldArray[notificationIndex].callback;
                            if (callBackFunction) {
                                callBackFunction(true);
                            }
                        }
                        let updateNotificationData = { ...oldArray[notificationIndex] };
                        updateNotificationData.callAccepted = true;
                        oldArray[notificationIndex] = { ...updateNotificationData };
                        newValueState.inComingCallInstanceTrigger = true;
                        newValueState.audioNotificationData = oldArray[notificationIndex];
                        newValueState.callDetails = currentVoiceCallInstance[0];
                        if (newValueState.holdCallDetails.addParticipant){
                            newValueState.audioNotificationData.addParticipant = true;
                        }else{
                            newValueState.audioNotificationData.addParticipant = false;
                        }
                        newValueState.notificationData = [...oldArray];
                    }
                } else {
                    showToaster(
                        {
                            dialogBgColor: 'bg-danger',
                            dialogMsg: "Call has been disconnected by tenant",
                            showDialog: true,
                            timer: '5000'
                        }
                    );
                    terminateVoiceCall({ callerId: callerId, disconnectCall: true });
                }
                newValueState.holdCallDetails = undefined;
            }
            return newValueState;
        },
        removeInComingVoiceCallNotification: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            if (newValueState.notificationData.length === 1) {
                newValueState.playNotificationRinger = false;
            }
            const filteredValue = newValueState.notificationData.filter(
                (item) => checkCallSid(item.call_sid) !== checkCallSid(action.payload)
            );
            if (filteredValue){
                let missedNotification: string | null = localStorage.getItem("missed_notification");
                let missedNotificationArray: Array<any> = [];
                if (missedNotification){
                    missedNotificationArray = JSON.parse(missedNotification);
                }else{
                    missedNotificationArray = [];
                }
                localStorage.setItem("missed_notification", JSON.stringify([...missedNotificationArray, ...newValueState.notificationData.filter(notification => !filteredValue.includes(notification))]));
                newValueState.missedNotificationTrigger = true;

            }
            const filteredIncomingCallInstance = newValueState.voiceCallInstance.filter((voiceCallInstance: any) => checkCallSid(voiceCallInstance['customParameters'].get('call_sid')) !== checkCallSid(action.payload));
            newValueState.notificationData = [...filteredValue];
            newValueState.voiceCallInstance = [...filteredIncomingCallInstance];
            return newValueState;
        },
        terminateVoiceCall: (state, action: PayloadAction<DtoTerminateVoiceCall>) => {
            let newValueState: DtoAgentNotification = { ...state };
            let callDisconnected: boolean = true;
            let audioNotificationData = undefined;
            if (newValueState.audioNotificationData && newValueState.audioNotificationData.call_sid && checkCallSid(newValueState.audioNotificationData.call_sid) === checkCallSid(action.payload.callerId)) {
                if (newValueState.holdCallDetails === undefined || ( newValueState.holdCallDetails && newValueState.holdCallDetails.callSid && checkCallSid(newValueState.audioNotificationData.call_sid) !== checkCallSid(newValueState.holdCallDetails.callSid) ) || ( newValueState.holdCallDetails && newValueState.holdCallDetails.token )){
                    disconnectAudioCall(newValueState.inCallNotificationIdRef, checkCallSid(action.payload.callerId));
                }
                newValueState.callAccepted = false;
                newValueState.callDetails = undefined;
                audioNotificationData = newValueState.audioNotificationData;
                newValueState.audioNotificationData = undefined;
                newValueState.inCallNotificationIdRef = undefined
                callDisconnected = false;
            } else {
                // eslint-disable-next-line no-self-assign
                newValueState.audioNotificationData= newValueState.audioNotificationData;
                // eslint-disable-next-line no-self-assign
                newValueState.audioNotificationData = newValueState.audioNotificationData;
            }
            if (newValueState.holdCallDetails === undefined || (audioNotificationData &&  newValueState.holdCallDetails && checkCallSid(newValueState.holdCallDetails.callSid) && checkCallSid(audioNotificationData.call_sid) !== checkCallSid(newValueState.holdCallDetails.callSid) )  || (newValueState.holdCallDetails && newValueState.holdCallDetails.token)){
                const filteredValue = newValueState.notificationData.filter(
                    (item) => checkCallSid(item.call_sid) !== checkCallSid(action.payload.callerId)
                );
                if (filteredValue && callDisconnected){

                    let missedNotification: string | null = localStorage.getItem("missed_notification");
                    let missedNotificationArray: Array<any> = [];
                    if (missedNotification){
                        missedNotificationArray = JSON.parse(missedNotification);
                    }else{
                        missedNotificationArray = [];
                    }
                    localStorage.setItem("missed_notification", JSON.stringify([...missedNotificationArray, ...newValueState.notificationData.filter(notification => !filteredValue.includes(notification))]));
                    newValueState.missedNotificationTrigger = true;
                }
                newValueState.notificationData = [...filteredValue];
            }
            // Handling the NotificationRinger sound
            if (newValueState.notificationData.length <= 0) {
                newValueState.playNotificationRinger = false;
            }else if (newValueState.notificationData.length === 2 && newValueState.playNotificationRinger === false && !newValueState.holdCallDetails){
                newValueState.playNotificationRinger = true;
            }else if (newValueState.notificationData.length > 2 && newValueState.playNotificationRinger === false && newValueState.holdCallDetails === undefined){
                newValueState.playNotificationRinger = true;
            }
            let changedVoiceNotificationData = newValueState.voiceCallInstance;
            const currentVoiceCallInstance = changedVoiceNotificationData.filter((voiceCallInstance: any) => checkCallSid(voiceCallInstance['customParameters'].get('call_sid')) === checkCallSid(action.payload.callerId));

            if (currentVoiceCallInstance && currentVoiceCallInstance.length > 0) {
                if (action.payload.disconnectCall) {
                    newValueState.disconnectCall = true;
                    newValueState.audioCallTimer = 0;
                    newValueState.audioCallStartTimer = false;
                    newValueState.disconnectEndCallId = checkCallSid(action.payload.callerId);
                }
                // changedVoiceNotificationData = newValueState.voiceCallInstance.filter((voiceCallInstance: any) => voiceCallInstance['customParameters'].get('call_sid') !== action.payload.callerId);
            }
            newValueState.voiceCallAudioMute = false;
            newValueState.device.audio.unsetInputDevice().then(() => {
                console.info('Success!');
            });
            return newValueState;
        },
        endOnHoldVoiceCall:(state, action: PayloadAction<{callSid: string, tenantDisconnects: boolean}>) => {
            const callSid = checkCallSid(action.payload.callSid);
            const tenantDisconnects = action.payload.tenantDisconnects;
            let newValueState: DtoAgentNotification = { ...state };

            if (newValueState.holdCallDetails && newValueState.holdCallDetails.callSid && checkCallSid(newValueState.holdCallDetails.callSid) === callSid) {
                const filteredValue = newValueState.notificationData.filter((item) => checkCallSid(item.call_sid) !== callSid);
                newValueState.notificationData = [...filteredValue];
                newValueState.holdCallDetails = undefined;
            }else if (checkCallSid(newValueState.audioNotificationData?.call_sid) === callSid){
                const currentVoiceCallInstance = newValueState.voiceCallInstance.filter((voiceCallInstance: any) => checkCallSid(voiceCallInstance['customParameters'].get('call_sid')) === callSid);
                if (currentVoiceCallInstance && currentVoiceCallInstance.length > 0) {
                        const inCallNotificationIdRef = newValueState.inCallNotificationIdRef;
                        disconnectAudioCall(inCallNotificationIdRef, callSid);
                        newValueState.disconnectCall = true;
                        newValueState.audioCallTimer = 0;
                        newValueState.audioCallStartTimer = false;
                        newValueState.disconnectEndCallId = checkCallSid(callSid);
                        newValueState.inCallNotificationIdRef = undefined
                        newValueState.callAccepted = false;
                        newValueState.callDetails = undefined;
                        newValueState.audioNotificationData = undefined;
                        newValueState.voiceCallAudioMute = false;
                        if (tenantDisconnects){
                            newValueState.errorMessageToaster = 'Call has been disconnected by tenant';
                        }
                }
            }else{
                const filteredValue = newValueState.notificationData.filter((item) => checkCallSid(item.call_sid) !== callSid);
                if (newValueState.notificationData.length === 1 || (newValueState.notificationData.length === 2 && newValueState.holdCallDetails)) {
                    newValueState.playNotificationRinger = false;
                }
                if (filteredValue){
                    let missedNotification: string | null = localStorage.getItem("missed_notification");
                    let missedNotificationArray: Array<any> = [];
                    if (missedNotification){
                        missedNotificationArray = JSON.parse(missedNotification);
                    }else{
                        missedNotificationArray = [];
                    }
                    localStorage.setItem("missed_notification", JSON.stringify([...missedNotificationArray, ...newValueState.notificationData.filter(notification => !filteredValue.includes(notification))]));
                    newValueState.missedNotificationTrigger = true;
                }
                newValueState.notificationData = [...filteredValue];
            }
            return newValueState;
        },
        endOnHoldVideoCall:(state, action: PayloadAction<DtoUpdateVideoRoomDetails>) => {
            const roomSid = action.payload.roomSid;
            const locationId = action.payload.locationId;
            const notificationId = action.payload.notificationId? action.payload.notificationId : undefined;
            let newValueState: DtoAgentNotification = { ...state };

            if (newValueState.holdCallDetails && newValueState.holdCallDetails.roomData && newValueState.holdCallDetails.roomData && newValueState.holdCallDetails.roomData.room_sid && newValueState.holdCallDetails.roomData.locationId && newValueState.holdCallDetails.roomData.room_sid === roomSid && newValueState.holdCallDetails.roomData.locationId === locationId) {
                const filteredValue = newValueState.notificationData.filter((item) => item.locationId !== locationId);
                newValueState.notificationData = [...filteredValue];
                newValueState.holdCallDetails = undefined;
            }else if (newValueState.videoRoomDetails && newValueState.videoRoomDetails.locationId && newValueState.videoRoomDetails.room_sid && newValueState.videoRoomDetails.locationId === locationId && newValueState.videoRoomDetails.room_sid === roomSid){
                newValueState.videoCallTriggerFlag = { roomSid: action.payload.roomSid, locationId: action.payload.locationId, isAutomateTerminate: false, IsManualCall: 'false', notificationId: notificationId? "no" : "yes" }
            }else{
                const filteredValue = newValueState.notificationData.filter((item) => item.locationId !== locationId);
                if (newValueState.notificationData.length === 1 || (newValueState.notificationData.length === 2 && newValueState.holdCallDetails)) {
                    newValueState.playNotificationRinger = false;
                }
                if (filteredValue){
                    let missedNotification: string | null = localStorage.getItem("missed_notification");
                    let missedNotificationArray: Array<any> = [];
                    if (missedNotification){
                        missedNotificationArray = JSON.parse(missedNotification);
                    }else{
                        missedNotificationArray = [];
                    }
                    localStorage.setItem("missed_notification", JSON.stringify([...missedNotificationArray, ...newValueState.notificationData.filter(notification => !filteredValue.includes(notification))]));
                    newValueState.missedNotificationTrigger = true;
                }
                newValueState.notificationData = [...filteredValue];
            }
            return newValueState;
        },
        enableAddParticipantButton:(state, action: PayloadAction<string>) => {
            const call_sid = checkCallSid(action.payload);
            let newValueState: DtoAgentNotification = { ...state };
            if(newValueState.callDetails && checkCallSid(newValueState.callDetails['customParameters'].get('call_sid')) === call_sid){
                let callDetails = Object.assign({}, newValueState.audioNotificationData);
                callDetails.addParticipant = true;
                newValueState.audioNotificationData = callDetails;
            }else if (newValueState.holdCallDetails && newValueState.holdCallDetails.callSid && checkCallSid(newValueState.holdCallDetails.callSid) === call_sid){
                let callDetails = Object.assign({}, newValueState.holdCallDetails);
                callDetails.addParticipant = true;
                newValueState.holdCallDetails = callDetails;
            }else if (newValueState.outBoundCallConnection && newValueState.outBoundCallConnection.parameters.CallSid && checkCallSid(newValueState.outBoundCallConnection.parameters.CallSid) === call_sid){
                newValueState.outBoundCallAddParticipant = true;
            }
            return newValueState;
        },
        disableAddParticipantButton: (state) => {
            let newValueState: DtoAgentNotification = { ...state };
            if(newValueState.callDetails){
                let callDetails = Object.assign({}, newValueState.audioNotificationData);
                callDetails.addParticipant = false
                newValueState.audioNotificationData = callDetails;
            }else if (newValueState.outBoundCallConnection){
                newValueState.outBoundCallAddParticipant = false;
            }
            return newValueState;
        },
        terminateManualVideoCall: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            const oldArray: Array<DtoIncomingNotification> = [...state.notificationData];
            let notificationIndex: number = oldArray.findIndex((item) => item.notificationId === action.payload);
            if (oldArray && notificationIndex >=0 && oldArray[notificationIndex]) {
                let updateNotificationData = {...oldArray[notificationIndex]};
                updateNotificationData.callAccepted = false;
                oldArray[notificationIndex] = {...updateNotificationData};
            }
            newValueState.notificationData = [...oldArray];
            return newValueState;
        },
        resetDisconnectCall: (state) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.disconnectCall = false;
            newValueState.disconnectEndCallId = undefined;
            return newValueState;
        },
        resetAgentNotifications: (state) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.notificationData = [];
            newValueState.playNotificationRinger = false;
            newValueState.loopRinger = true;
            newValueState.inCallNotificationIdRef = undefined;
            newValueState.inDirectCall = false;
            newValueState.removedCallInstance = [];
            newValueState.defaultActiveKeys = ["0"];
            return newValueState;
        },
        setAudioCallErrorMessage : (state,action: PayloadAction<boolean>)=>{
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.audioCallError = action.payload;
            return newValueState
        },
        acceptIncomingVoiceCall: (state, action: PayloadAction<string>) => {
            let newValueState: DtoAgentNotification = { ...state };
            const callerId = action.payload;
            loggerHelper(callerId,'callerId');
            loggerHelper(newValueState.voiceCallInstance[0]?.['customParameters']?.get('call_sid'),'call_sid in voiceCallInstance ----------------------->');
            loggerHelper(newValueState.voiceCallInstance?.length,'call_sid in voiceCallInstance ----------------------->');
            const currentVoiceCallInstance = newValueState.voiceCallInstance.filter((voiceCallInstance: any) => {
                loggerHelper(voiceCallInstance['customParameters']?.get('call_sid'),'call_sid in voice_call_instance');
               return checkCallSid(voiceCallInstance['customParameters'].get('call_sid')) === callerId
            }
            );
            loggerHelper(currentVoiceCallInstance?.length,"currentVoiceCallInstance.length");
            if (callerId && currentVoiceCallInstance && currentVoiceCallInstance.length > 0) {
                currentVoiceCallInstance[0].accept();
                const oldArray: Array<DtoIncomingNotification> = [...newValueState.notificationData];
                let notificationIndex: number = oldArray.findIndex((item) => item.call_sid === callerId);
                loggerHelper('notificationIndex',notificationIndex);
                if (oldArray && oldArray[notificationIndex] && notificationIndex >= 0) {
                    loggerHelper("Inside the oldArray notification condition",oldArray[notificationIndex]);
                    if ("callback" in oldArray[notificationIndex] && oldArray[notificationIndex].callback && oldArray[notificationIndex].callback !== undefined) {
                        newValueState.inCallNotificationIdRef = oldArray[notificationIndex].notificationId;
                        const callBackFunction = oldArray[notificationIndex].callback;
                        if (callBackFunction) {
                            loggerHelper("Inside callback function",newValueState.inCallNotificationIdRef);
                            callBackFunction(true);
                        }
                    }
                    let updateNotificationData = { ...oldArray[notificationIndex] };
                    updateNotificationData.callAccepted = true;
                    oldArray[notificationIndex] = { ...updateNotificationData };
                    newValueState.inComingCallInstanceTrigger = true;
                    newValueState.audioNotificationData = oldArray[notificationIndex];
                    newValueState.callDetails = currentVoiceCallInstance[0];
                    newValueState.audioNotificationData.addParticipant = true;
                    newValueState.notificationData = [...oldArray];
                }
            } else {
            loggerHelper('inside else part before terminateVoiceCall function call', callerId);
                    disconnectAudioCall(undefined, callerId);
                    newValueState.audioCallError = true;
                    // showToaster(
                    //     {
                    //         dialogBgColor: 'bg-danger',
                    //         dialogMsg: "Call has been disconnected by tenant",
                    //         showDialog: true,
                    //         timer: '5000'
                    //     }
                    // );
                terminateVoiceCall({ callerId: callerId, disconnectCall: true });
            }
            return newValueState;
        },
        setHoldCallDetails: (state, action: PayloadAction<DtoCallHoldDetails | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            if (action.payload) {
                newValueState.holdCallDetails = {...action.payload};
            } else {
                newValueState.holdCallDetails = undefined;
            }
            return newValueState;
        },
        setAppLoader: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.appLoader = action.payload;
            return newValueState;
        },
        setHoldCallDetailsONTenantEnd: (state, action: PayloadAction<any>) => {
            let newValueState: DtoAgentNotification = { ...state };
            if(newValueState.holdCallDetails && ((action.payload.IsManualCall === "yes" && newValueState.holdCallDetails?.inCallLocationId === action.payload.inCallRefId) || (action.payload.IsManualCall === "no" && newValueState.holdCallDetails?.inCallRefId === action.payload.inCallRefId))){
                newValueState.holdCallDetails = undefined;
            }
            return newValueState;
        },
        updateDndTimer: (state) => {
            let newValueState: DtoAgentNotification = { ...state };
            const newDndTimer: any = {}
            Object.keys(newValueState.dndTimer).forEach((locationKey: string) => {
                if (locationKey !== "keys") {
                    if(newValueState.dndTimer[locationKey]>1000){
                        newDndTimer[locationKey] = newValueState.dndTimer[locationKey] - 1000;
                    }else{
                        newDndTimer[locationKey] = "";
                    }
                }
            })
            newValueState.dndTimer = newDndTimer
            return newValueState;
        },
        updateDndList: (state, action: PayloadAction<{[key: string]: number}>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.dndTimer = Object.assign({}, action.payload);
            return newValueState;
        },
        setVideoRoomDetails: (state, action: PayloadAction<DtoRoomData | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.videoRoomDetails = action.payload;
            return newValueState;
        },
        updateVideoRoomDetailsAddParticipantButton: (state, action: PayloadAction<DtoUpdateVideoRoomDetails>) => {
            let newValueState: DtoAgentNotification = { ...state };
            if (action.payload.locationId && action.payload.roomSid && newValueState.videoRoomDetails && newValueState.videoRoomDetails.locationId && newValueState.videoRoomDetails.room_sid && newValueState.videoRoomDetails.locationId === action.payload.locationId && newValueState.videoRoomDetails.room_sid === action.payload.roomSid){
                let videoRoomDetails = Object.assign({}, newValueState.videoRoomDetails);
                videoRoomDetails.addParticipant = action.payload.condition;
                newValueState.videoRoomDetails = videoRoomDetails;
            }else if(action.payload.locationId && action.payload.roomSid && newValueState.holdCallDetails && newValueState.holdCallDetails.roomData && newValueState.holdCallDetails.roomData.locationId && newValueState.holdCallDetails.roomData.room_sid && newValueState.holdCallDetails.roomData.locationId === action.payload.locationId && newValueState.holdCallDetails.roomData.room_sid === action.payload.roomSid){
                let holdCallDetails = Object.assign({}, newValueState.holdCallDetails);
                if (holdCallDetails.roomData){
                    holdCallDetails.roomData.addParticipant = action.payload.condition;
                }
                newValueState.holdCallDetails = holdCallDetails;
            }
            return newValueState;
        },
        triggerVideoCallEndFunction: (state, action: PayloadAction<DtoUpdateVideoRoomDetails | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.inHandOffCall = undefined;
            newValueState.videoCallTriggerFlag = action.payload;
            return newValueState;
        },
        setMissedCallNotificationTrigger: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.missedNotificationTrigger = action.payload;
            return newValueState;
        },

        setVoiceMailNotificationTrigger: (state, action: PayloadAction<boolean>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.voiceMailNotificationTrigger = action.payload;
            return newValueState;
        },

        setLocationDetails: (state, action: PayloadAction<{ [index: string]: DtoLocationDetails }>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.locationDetails = {...action.payload};
            return newValueState;
        },
        setErrorMessageToaster: (state, action: PayloadAction<string | undefined>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.errorMessageToaster = action.payload;
            return newValueState;
        },
        setLocationsData: (state, action: PayloadAction<DtoLocationData>) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.locationsData = action.payload;
            return newValueState;
        },

        removeLocIdFromRestartMotionStateData:(state,action:PayloadAction<string>)=>{
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.restartMotionStateLocationId = newValueState.restartMotionStateLocationId.filter((item:any)=>(item !== action.payload));
            return newValueState;
        },

        setRestartMotionStateLocationData:(state , action:PayloadAction<string[]> ) => {
            let newValueState: DtoAgentNotification = { ...state };
            newValueState.restartMotionStateLocationId = [...action.payload];
            return newValueState;
        },

        setAudioOutputDeviceChanged :(state , action:PayloadAction<boolean>)=>{
            let newValueState: DtoAgentNotification = {...state};
            newValueState.triggersetSinkId = action.payload;
            return newValueState;  
        },

        setDeviceForNotificationAudio:(state,action:PayloadAction<{[index:string]:string}>) =>{
            let newValueState: DtoAgentNotification = {...state};
            newValueState.notificationAudioDevice = action.payload;
            newValueState.triggersetSinkId = true;
            newValueState.enableDisable = action.payload ? Object.keys(action.payload)[0] : "";
            return newValueState;
        },

        setEnableDisableDropDown:(state,action:PayloadAction<string | null>) =>{
            let newValueState: DtoAgentNotification = {...state};
            newValueState.enableDisable = action.payload;
            return newValueState;
        },
    },
});

export const {
    setAgentNotifications,
    setInHandOffCall,
    removeAudioCallNotificationById,
    playPauseRinger,
    setLoopRinger,
    setInCallNotificationIdRef,
    setInDirectCall,
    setRemovedCallInstance,
    setInComingCallInstanceTrigger,
    acceptIncomingVoiceCall,
    setDefaultActiveKeys,
    setAudioNotificationData,
    setOutBoundCallLocationDetails,
    terminateOutBoundVoiceCall,
    setTerminatedOutBoundVoiceCall,
    setVoiceCallAudioMute,
    setOutBoundCallPhoneNumber,
    setOutBoundCallFromPhoneNumber,
    setOutBoundCallConnection,
    setAudioCallTimer,
    setAudioCallStartTimer,
    setAgentToAgentOutBoundVoiceCallAgentId,
    setAgentToAgentOutBoundVoiceCallAgentDetails,
    setCallAccepted,
    setCallDetails,
    setNotificationsListener,
    initializeAudioDevice,
    setVoiceCallInstance,
    setHoldCallDetails,
    setHoldCallDetailsONTenantEnd,
    appendVoiceCallInstance,
    removeInComingVoiceCallNotification,
    terminateVoiceCall,
    resetDisconnectCall,
    terminateManualVideoCall,
    resetAgentNotifications,
    endOnHoldVoiceCall,
    setAppLoader,
    updateDndList,
    updateDndTimer,
    enableAddParticipantButton,
    disableAddParticipantButton,
    setVideoRoomDetails,
    updateVideoRoomDetailsAddParticipantButton,
    endOnHoldVideoCall,
    triggerVideoCallEndFunction,
    setMissedCallNotificationTrigger,
    setVoiceMailNotificationTrigger,
    setLocationDetails,
    setErrorMessageToaster,
    setLocationsData,
    setRestartMotionStateLocationData,
    removeLocIdFromRestartMotionStateData,
    setDeviceForNotificationAudio,
    setAudioOutputDeviceChanged,
    setEnableDisableDropDown,
    setAudioCallErrorMessage
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
